export function randomString(length: number): string {
  let result = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

/**
 * 递归 URL 解码（最多 3 层）：兼容历史上被 encode 一次/两次入库的中文会议名。
 * 纯 ASCII 无 % 的名称原样返回。
 */
export function decodeRoomName(name: string): string {
  let out = name;
  for (let i = 0; i < 3; i++) {
    try {
      const d = decodeURIComponent(out);
      if (d === out) break;
      out = d;
    } catch {
      break;
    }
  }
  return out;
}
